import { Dispatch } from "redux"
import { ActivityType } from "../../types/activityType"
import { ActionType } from "../action-types"
import { Action } from "../actions/index"

export const addActivities = (activities:ActivityType[]) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.ADD_ACTIVITIES,
            payload: activities
        })
    }
}

export const setActivities = (activities:ActivityType[]) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.SET_ACTIVITIES,
            payload: activities
        })
    }
}

export const setSelectedActivity = (activity:ActivityType) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.SET_SELECTED_ACTIVITY,
            payload: activity
        })
    }
}
